import { i18n } from '../../i18n';




export const filterColumnsHash = {
  slug_cont: {
    label: i18n.t('customPage.slug'),
    renderCell: {
      component: 'input'
    }
  },
  title_cont: {
    label: i18n.t('customPage.title'),
    renderCell: {
      component: 'input'
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('customPage.id'),
    width: 80,
  },
  slug: {
    label: i18n.t('customPage.slug'),
  },
  title: {
    label: i18n.t('customPage.title'),
  },
  default: {
    label: i18n.t('customPage.default'),
    renderCell: 'bool',
  },
  created_at: {
    label: i18n.t('customPage.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('customPage.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
}

export const formColumnsHash = {
  slug: {
    label: i18n.t('customPage.slug'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  title: {
    label: i18n.t('customPage.title'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
}
